import React from 'react';
import { DeletedIcon } from 'components/TableIcon';
import { GoneIcon } from 'components/TableIcon';
import { ClosedIcon } from 'components/TableIcon';
import useDataFetching from 'hooks/useDataFetching';
import { formatDate } from 'utils';
import { config } from 'variables/config';

export const ROLESF = () => {
  const [loadingR, errorR, roles, fetchDataU] = useDataFetching(`${config.app.api_url}/roles`);
  let rolesArray = [];
  roles?.data &&
    roles?.data?.map((role) => {
      rolesArray.push(role?.name);
    });
  return rolesArray;
};

export const ROLES = ['AGENT', 'DGSN', 'ADMIN', 'MINREX', 'QUALITY'];
export const ROLES_LIST = Object.freeze({
  AGENT: 'AGENT',
  DGSN: 'DGSN',
  ADMIN: 'ADMIN',
  MINREX: 'MINREX',
  QUALITY: 'QUALITY',
  DRMO: 'DRMO',
});
export const PERMISSIONS = [
  'Filtres et Affichages',
  'Imprimer toutes les statistiques',
  'Voir une entreprise sur google map',
  'Consulter une entreprise',
  'Consulter travailleur',
  'Voir map',
  'Ajouter un agent',
  'Ajouter un employer',
  'Ajouter une entreprise',
  "Modifier les informations d'un agent",
  'Ajouter un compte',
  "Modifier les informations d'un utilisateur",
  'Ajouter un rôle',
  'Attribuer des permissions à un rôle',
  "Modifier les informations d'un rôle",
  'Voir menu statistiques',
  'Voir menu entreprise',
  'Voir liste des employes',
  'Voir liste regions',
  'Voir menu comptes agents',
  'Voir menu gestion des comptes',
  'Entreprises enregistrées par un agent',
  'Employés enregistrées par un agent',
  'Voir menu gestion des roles',
  'Voir menu employé',
];

export function CHECK_PERMISSIONS(permissions, key) {
  let permArray = [];
  if (key == null || key == undefined) {
    return true;
  } else {
    permissions?.length > 0 &&
      permissions?.map((perm) => {
        permArray.push(perm?.name);
      });
    if (permArray.includes(key)) {
      return true;
    }
    return false;
  }
}

export function CHECK_ROLES_PERMISSIONS(roles, key) {
  let res = false;
  roles?.forEach((role) => {
    if (CHECK_PERMISSIONS(role?.permissions, key)) {
      res = true;
    }
  });
  return res;
}

export const ENTERPRISE_HEADER = [
  { id: 'N', label: 'header_number', minWidth: 20 },
  { id: 'Raison', label: 'header_social_reason', minWidth: 300 },
  {
    id: 'Secteur',
    label: 'header_activity_sector',
    minWidth: 20,
    maxWidth: 20,
  },
  {
    id: 'Arrondissement',
    label: 'header_arrondissement',
    minWidth: 20,
    maxWidth: 50,
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'Expatriés',
    label: 'header_expatriates_number',
    minWidth: 20,
    maxWidth: 50,
    align: 'right',
  },
  {
    id: 'Coordonnées',
    label: 'header_location',
    minWidth: 10,
    align: 'center',
  },
  {
    id: 'Options',
    label: 'header_options',
    minWidth: 10,
    align: 'center',
  },
];

export const ENTERPRISE_REQUEST_HEADER = (t) => [
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'RequestId', label: 'RequestId', minWidth: 20 },
  { id: 'Raison', label: t('company_name'), minWidth: 150 },

  {
    id: 'Niu',
    label: t('niu'),
    minWidth: 20,
    maxWidth: 20,
  },
  {
    id: 'Motif',
    label: t('motif'),
    minWidth: 200,
  },
  {
    id: 'Type',
    label: t('type'),
    minWidth: 20,
    maxWidth: 50,
  },
  {
    id: 'Date',
    label: t('date'),
    minWidth: 10,
    maxWidth: 50,

    align: 'center',
    format: (value) => formatDate(value),
  },
  {
    id: 'Status',
    label: t('status'),
    minWidth: 70,
  },
  {
    id: 'Options',
    label: t('options'),
    minWidth: 10,
    align: 'center',
  },
];
export const getEmployerHeaderWithHistory = (t) => [
  { id: ' ', label: '', minWidth: 20 },
  ...getEmployerHeader(t),
];

export const getEmployerHeader = (t) => [
  { id: 'N', label: t('table_column_number'), minWidth: 20 },
  { id: 'Noms', label: t('table_column_full_name'), minWidth: 300 },
  {
    id: 'Poste',
    label: t('table_column_position'),
    minWidth: 20,
    maxWidth: 50,
  },
  {
    id: 'entreprise',
    label: t('table_column_company'),
    minWidth: 30,
    maxWidth: 50,
  },
  // {
  //   id: 'Salaire',
  //   label: t('table_column_salary'),
  //   minWidth: 100,
  //   format: (value) => value.toLocaleString('en-US'),
  // },
  {
    id: 'Nationalité',
    label: t('table_column_nationality'),
    minWidth: 100,
    format: (value) => value?.toLowerCase(),
  },
  {
    id: 'Date',
    label: t('table_column_permit_expiration'),
    minWidth: 100,
  },
  {
    id: 'Status',
    label: t('table_column_permit_status'),
    minWidth: 70,
    align: 'center',
  },
  {
    id: 'Options',
    label: t('table_column_options'),
    minWidth: 70,
    align: 'center',
  },
];

export const EMLOYEE_REQUEST_HEADER = (t) => [
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'RequestId', label: t('RequestId'), minWidth: 20 },
  { id: 'Raison', label: t('company_name'), minWidth: 60 },
  { id: 'Noms', label: t('names'), minWidth: 60 },
  {
    id: 'Nationality',
    label: t('nationality'),
    minWidth: 20,
    // maxWidth: 70,
  },
  {
    id: 'Motif',
    label: t('motif'),
    minWidth: 100,
  },
  {
    id: 'Type',
    label: t('type_request'),
    minWidth: 20,
    maxWidth: 50,
  },
  {
    id: 'Date',
    label: t('date'),
    minWidth: 10,
    maxWidth: 50,

    align: 'center',
    format: (value) => formatDate(value),
  },
  {
    id: 'Status',
    label: t('status'),
    minWidth: 70,
  },
  {
    id: 'Options',
    label: t('options'),
    minWidth: 10,
    align: 'center',
  },
];

export const getReportHeaders = (t) => {
  return [
    { id: 'N', label: t('table_header_N'), minWidth: 20 },
    { id: 'Noms', label: t('table_header_Noms'), minWidth: 50 },
    { id: 'Date', label: t('table_header_Date'), minWidth: 50 },
    {
      id: 'Title',
      label: t('table_header_Title'),
      minWidth: 20,
    },
    {
      id: 'SubmitDate',
      label: t('table_header_SubmitDate'),
      minWidth: 100,
      maxWidth: 300,
    },
    {
      id: 'Valide',
      label: t('table_header_Status'),
      minWidth: 100,
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'Options',
      label: t('table_header_Options'),
      minWidth: 70,
      align: 'center',
    },
  ];
};

export const REPORT_DOC_HEADER = (t) => [
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'Region', label: t('reports:region'), minWidth: 50 },
  { id: 'Date', label: t('reports:date'), minWidth: 50 },
  {
    id: 'Title',
    label: t('reports:title'),
    minWidth: 20,
  },
];

export const DEMANDE_HEADER = (t) => [
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'Noms', label: t('header_contract_number'), minWidth: 50 }, // Traduit
  { id: 'Date', label: t('header_employer_name'), minWidth: 50 }, // Traduit

  {
    id: 'Title',
    label: t('header_enterprise_name'), // Traduit
    minWidth: 20,
  },

  {
    id: 'SubmitDate',
    label: t('header_salary'), // Traduit
    minWidth: 100,
    maxWidth: 300,
  },
  {
    id: 'Rating',
    label: t('header_last_modified_date'), // Traduit
    maxWidth: 100,
  },
  {
    id: 'Valide',
    label: t('header_status'), // Traduit
    minWidth: 100,
    // align: 'right',
    format: (value) => value.toLocaleString('en-US'),
  },

  {
    id: 'Options',
    label: t('header_options'), // Traduit
    minWidth: 70,
    align: 'center',
  },
];

export const CONTRACTS_HEADER = [
  { id: ' ', label: ' ', minWidth: 20 },
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'Noms', label: 'Noms', minWidth: 300 },

  {
    id: 'Poste',
    label: 'Poste',
    minWidth: 20,
    maxWidth: 50,
  },
  {
    id: 'entreprise',
    label: 'Entreprise',
    minWidth: 30,
    maxWidth: 50,
  },
  {
    id: 'Salaire',
    label: 'Salaire',
    minWidth: 100,
    // align: 'right',
    format: (value) => value.toLocaleString('en-US'),
  },
  {
    id: 'Nationalité',
    label: 'Nationalité',
    minWidth: 100,
    format: (value) => value?.toLowerCase(),
  },
  {
    id: 'Date',
    label: "Date d'expiriration du permis",
    minWidth: 100,
  },
  {
    id: 'Status',
    label: 'Status',
    minWidth: 70,
    align: 'center',
  },
  {
    id: 'Options',
    label: 'Options',
    minWidth: 70,
    align: 'center',
  },
];

export const CONTRACT_REQUEST_HEADER = (t) => [
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'RequestId', label: 'RequestId', minWidth: 20 },
  { id: 'Raison', label: t('company_name'), minWidth: 50 },
  { id: 'Noms', label: t('names'), minWidth: 50 },
  {
    id: 'Nationality',
    label: t('nationality'),
    minWidth: 20,
    maxWidth: 20,
  },
  {
    id: 'Salary',
    label: t('salary'),
    minWidth: 20,
    maxWidth: 20,
  },
  {
    id: 'Motif',
    label: t('motif'),
    minWidth: 100,
  },
  {
    id: 'Type',
    label: t('type_request'),
    minWidth: 20,
    maxWidth: 50,
  },
  {
    id: 'Date',
    label: t('date'),
    minWidth: 10,
    maxWidth: 50,

    align: 'center',
    format: (value) => formatDate(value),
  },
  {
    id: 'Status',
    label: t('status'),
    minWidth: 70,
  },
  {
    id: 'Options',
    label: t('options'),
    minWidth: 10,
    align: 'center',
  },
];

export const ENTRY_TYPE = {
  SHORT_VISA: 'Visa court séjour',
  LONG_VISA: 'Visa Long séjour',
  SEJOUR_CARD: 'Carte séjour',
  RESIDENT_CARD: 'Carte de résident',
};

export const ZONES = [
  { value: 1, label: 'Zone 1' },
  { value: 2, label: 'Zone 2' },
  { value: 3, label: 'Zone 3' },
  { value: 4, label: 'Zone 4' },
];

export const getMissionHeader = (t) => [
  { id: ' ', label: ' ', minWidth: 20 },
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'description', label: t('description'), minWidth: 200 },
  {
    id: 'debut',
    label: t('start_date'),
    minWidth: 120,
  },
  {
    id: 'fin',
    label: t('end_date'),
    minWidth: 120,
  },
  {
    id: 'region',
    label: t('region'),
    minWidth: 120,
  },
  {
    id: 'actions',
    label: 'Actions',
    minWidth: 120,
  },
];

export const TASK_HEADER = (t) => [
  { id: ' ', label: ' ', minWidth: 20 },
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'description', label: t('description'), minWidth: 200 },

  {
    id: 'debut',
    label: t('start_date'),
    minWidth: 120,
  },
  {
    id: 'fin',
    label: t('end_date'),
    minWidth: 120,
  },
  {
    id: 'region',
    label: t('region'),
    minWidth: 120,
  },
  {
    id: 'department',
    label: t('department'),
    minWidth: 120,
  },
  {
    id: 'arrondissement',
    label: t('arrondissement'),
    minWidth: 120,
  },
  {
    id: 'zone',
    label: t('zone'),
    minWidth: 120,
  },
  {
    id: 'status',
    label: t('status'),
    minWidth: 120,
  },
  {
    id: 'actions',
    label: t('actions'),
    minWidth: 120,
  },
];
export const getZoneHeader = (t) => [
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'Zone', label: t('name'), minWidth: 20 },
  { id: 'description', label: t('description'), minWidth: 200 },
  {
    id: 'departement',
    label: t('department'),
    minWidth: 120,
  },
  {
    id: 'region',
    label: t('region'),
    minWidth: 120,
  },

  {
    id: 'actions',
    label: t('actions'),
    minWidth: 120,
  },
];

export const AGENT_HEADER = (t) => [
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'noms', label: t('name_and_surname'), minWidth: 200 },
  { id: 'phone', label: t('telephone'), minWidth: 100 },
  {
    id: 'department',
    label: t('registered_enterprises'),
    minWidth: 120,
  },
  {
    id: 'employees',
    label: t('registered_employees'),
    minWidth: 120,
  },

  {
    id: 'Options',
    label: t('actions'),
    minWidth: 120,
  },
];

export const ACCOUNT_HEADER = (t) => [
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'FirstName', label: t('firstname_label'), minWidth: 200 },
  { id: 'LastName', label: t('lastname_label'), minWidth: 200 },
  {
    id: 'Email',
    label: t('email_label'),
    minWidth: 120,
  },
  {
    id: 'Phone',
    label: t('phone_label'),
    minWidth: 120,
  },
  {
    id: 'Enable',
    label: t('status'),
    minWidth: 120,
  },
  {
    id: 'Options',
    label: t('actions'),
    minWidth: 120,
  },
];

export const ENTERPRISE_STATUS = {
  CREATED: {
    value: 'CREATED',
    label: 'Created',

    alert:
      'Etes vous Sur de vouloir restaurer cette entrprises ? Cela impliquera egalement la restauration de ses employées',
  },
  CLOSED: {
    value: 'CLOSED',
    label: 'Closed',
    alert: 'Etes vous Sur de vouloir marquer cette entrprise comme fermer ?',
    icon: <ClosedIcon />,
  },
  DELETED: {
    value: 'DELETED',
    label: 'Deleted',
    icon: <DeletedIcon />,
    alert:
      'Etes vous Sur de vouloir supprimer cette entrprise ? Cela impliquera egalement la suppression de ses employées',
  },
};

export const EMPLOYER_STATUS = {
  CREATED: {
    value: 'CREATED',
    label: 'Created',

    alert: 'Etes vous Sur de vouloir restaurer cette employe ? ',
  },
  GONE: {
    value: 'GONE',
    label: 'Parti',
    alert: 'Etes vous Sur de vouloir marquer cette entrprise comme parti ?',
    icon: <GoneIcon />,
  },
  DELETED: {
    value: 'DELETED',
    label: 'Supprimer',

    alert: 'Etes vous Sur de vouloir supprimer cet expatrié ?',
    icon: <DeletedIcon />,
  },
};

export const EWORK_DEMANDE_STATUS = {
  RQ_SUBMITTED: {
    label: 'Submitted',
    value: 'RQ_SUBMITTED',
    displayLabel: 'Submitted',
  },
  RQ_UNDER_PROCESS: {
    label: 'Under Process',
    value: 'RQ_UNDER_PROCESS',
    displayLabel: 'Under Process',
  },
  RQ_SENT_FOR_VALIDATION: {
    label: 'Sent for Validation',
    value: 'RQ_SENT_FOR_VALIDATION',
    displayLabel: 'Sent for Validation',
  },
  RQ_REJECTED: {
    label: 'Rejected',
    value: 'RQ_REJECTED',
    displayLabel: 'Rejected',
  },
  RQ_DELETED: {
    label: 'Deleted',
    value: 'RQ_DELETED',
    displayLabel: 'Deleted',
  },
  RQ_UNLOCKED: {
    label: 'Unlocked',
    value: 'RQ_UNLOCKED',
    displayLabel: 'Unlocked',
  },
  RQ_VALIDATED: {
    label: 'Validated',
    value: 'RQ_VALIDATED',
    displayLabel: 'Validated',
  },
  RQ_PAID: {
    label: 'Paid',
    value: 'RQ_PAID',
    displayLabel: 'Paid',
  },
  RQ_EWORKPERMIT: {
    label: 'E-Work Permit',
    value: 'RQ_EWORKPERMIT',
    displayLabel: 'E-Work Permit',
  },
  RQ_VERIFIED: {
    label: 'Verified',
    value: 'RQ_VERIFIED',
    displayLabel: 'Verified',
  },
  RQ_INCOMPLETED: {
    label: 'Incomplete',
    value: 'RQ_INCOMPLETED',
    displayLabel: 'Incomplete',
  },
  RQ_PICKED: {
    label: 'Picked',
    value: 'RQ_PICKED',
    displayLabel: 'Picked',
  },
};

export const NOTIFICATION_SCOPE = {
  USER: 'USER',
  REGION: 'REGION',
  GLOBAL: 'GLOBAL',
};

export const REQUEST_TYPE = {
  CREATE: { value: 'CREATE', label: 'creation' },
  UPDATE: { value: 'UPDATE', label: 'mise a jour' },
  DELETE: { value: 'DELETE', label: 'suppression' },
  CREATION_VERIFICATION: { value: 'CREATION_VERIFICATION', label: 'verification de creation' },
};

export const DEMANDE_STATUS = (t) => ({
  CREATED: {
    value: 'CREATED',
    label: t('status_created'), // Traduit
  },
  PENDING: {
    value: 'PENDING',
    label: t('status_pending'), // Traduit
  },
  AVAILABLE: {
    value: 'AVAILABLE',
    label: t('status_available'), // Traduit
  },
  EVALUATION_DONE: {
    value: 'EVALUATION_DONE',
    label: t('status_evaluation_done'), // Traduit
    shortLabel: t('status_evaluation_done_short'), // Traduit
  },
  REJECTED: {
    value: 'REJECTED',
    label: t('status_rejected'), // Traduit
  },
  DELETED: {
    value: 'DELETED',
    label: t('status_deleted'), // Traduit
  },
  TAKEN: {
    value: 'TAKEN',
    label: t('status_taken'), // Traduit
  },
});

export const REPORT_TYPE = Object.freeze({
  SPY: { id: 0, name: 'SPY' },
  AGENT: { id: 1, name: 'AGENT' },
  MISSION: { id: 2, name: 'MISSION' },
  REGULAR: { id: 2, name: 'REGULAR' },
});

export const ENTERPRISE_SPY_HEADER = (t) => [
  { id: 'N', label: '#', minWidth: 20 },
  { id: 'Raison', label: t('reports_doc:enterprise_name'), minWidth: 100 },

  {
    id: 'Ref',
    label: t('reports_doc:reference'),
    minWidth: 20,
    maxWidth: 20,
  },
  {
    id: 'NBE',
    label: t('reports_doc:employee_number_short'),
    minWidth: 20,
    maxWidth: 50,
    format: (value) => value?.toLocaleString('en-US'),
  },
  {
    id: 'RE',
    label: t('reports_doc:region'),
    minWidth: 20,
    maxWidth: 50,
  },
  {
    id: 'DE',
    label: t('reports_doc:department'),
    minWidth: 20,
    maxWidth: 50,
  },
  {
    id: 'AR',
    label: t('reports_doc:arrondissement'),
    minWidth: 20,
    maxWidth: 50,
  },
  {
    id: 'GPS',
    label: 'GPS',
    minWidth: 10,
    align: 'center',
  },
];
